<template>
  <div class="pta-admin">
    <div class="page-titles border-bottom">
      <h3>Limited Partners
        <span class="card-subtitle" v-if="investors">{{trans('general.total_result_found',{'count' : investors.total})}}</span>
        <span class="card-subtitle" v-else>{{trans('general.no_result_found')}}</span>

      </h3>
      <sort-by class="pull-right" :order-by-options="orderByOptions" :sort-by="filterInvestorForm.sort_by" :order="filterInvestorForm.order" @updateSortBy="value => {filterInvestorForm.sort_by = value}"  @updateOrder="value => {filterInvestorForm.order = value}"></sort-by>
      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showCreatePanel && hasPermission('create-user')" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">{{trans('investor.create_investor')}}</span></button>
    </div>
    <div class="container-fluid p-20" style="font-size: 0.625em;">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <div class="card border-bottom" v-if="showFilterPanel">
              <div class="card-body p-4">
                <h4 class="card-title">{{trans('general.filter')}}</h4>
                <div class="row">
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="hq_country">Label</label>
                      <select class="form-control" v-model="filterInvestorForm.label" name="active">
                        <option value="">All</option>
                        <option value="none">None</option>
                        <option v-for="(label, index) in labels" :key="label.name">
                          {{ label.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="name">{{trans('investor.name')}}</label>
                      <input class="form-control" id="name" name="name" v-model="filterInvestorForm.name">
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="contact_person">{{trans('investor.contact_person')}}</label>
                      <input class="form-control" id="contact_person" name="contact_person" v-model="filterInvestorForm.contact_person">
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="preferred_geography">Preferred Geography</label>
                      <v-select label="name" track-by="name" v-model="selected_preferred_geographies" name="preferred_geography" id="preferred_geography" :options="countries" :placeholder="'Please choose'" @select="onPreferredGeographySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onPreferredGeographyRemove" :selected="selected_preferred_geographies"></v-select>
                      <!-- <input class="form-control" id="preferred_geography" name="preferred_geography" v-model="filterInvestorForm.preferred_geography"> -->
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="preferred_fund_type_organization">Preferred Fund Type</label>
                      <v-select label="name" track-by="name" v-model="selected_preferred_fund_type_organizations" name="preferred_fund_type_organization" id="preferred_fund_type_organization" :options="investor_preferred_fund_types" :placeholder="'Please choose'" @select="onInvestorPreferredFundTypeSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onInvestorPreferredFundTypeRemove" :selected="selected_preferred_fund_type_organizations"></v-select>
                      <!-- <input class="form-control" id="preferred_fund_type_organization" name="preferred_fund_type_organization" v-model="filterInvestorForm.preferred_fund_type_organization"> -->
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="preferred_fund_type_organization">Limited Partner Type</label>
                      <v-select label="name" track-by="name" v-model="selected_limited_partner_type_organizations" name="limited_partner_type_organization" id="limited_partner_type_organization" :options="limited_partner_type_organizations" :placeholder="'Please choose'" @select="onLimitedPartnerTypeOrganizationSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onLimitedPartnerTypeOrganizationRemove" :selected="selected_limited_partner_type_organizations"></v-select>
                      <!-- <input class="form-control" id="preferred_fund_type_organization" name="preferred_fund_type_organization" v-model="filterInvestorForm.preferred_fund_type_organization"> -->
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="investment_structure">Investment Structure</label>
                      <v-select label="name" track-by="name" v-model="selected_investment_structures" name="investment_structure" id="investment_structure" :options="investment_structures" :placeholder="'Please choose'" @select="onInvestmentStructureSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onInvestmentStructureRemove" :selected="selected_investment_structures"></v-select>
                      <!-- <input class="form-control" id="investment_structure" name="investment_structure" v-model="filterInvestorForm.investment_structure"> -->
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="hq_country">HQ Country</label>
                      <v-select label="name" track-by="name" v-model="selected_hq_countries" name="hq_country" id="hq_country" :options="countries" :placeholder="'Please choose'" @select="onHQCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQCountryRemove" :selected="selected_hq_countries"></v-select>
                     <!-- <input class="form-control" id="hq_country" name="hq_country" v-model="filterInvestorForm.hq_country"> -->
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="hq_country">HQ Global Sub Region</label>
                      <v-select label="name" track-by="name" v-model="selected_hq_global_sub_regions" name="hq_global_sub_region" id="hq_global_sub_region" :options="regions" :placeholder="'Please choose'" @select="onHQGlobalSubRegionSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQGlobalSubRegionRemove" :selected="selected_hq_global_sub_regions"></v-select>
                      <!-- <input class="form-control" id="hq_country" name="hq_country" v-model="filterInvestorForm.hq_country"> -->
                    </div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <div class="form-group">
                      <label for="hq_country">HQ Global Region</label>
                      <v-select label="name" track-by="name" v-model="selected_hq_global_regions" name="hq_global_region" id="hq_global_region" :options="continents" :placeholder="'Please choose'" @select="onHQGlobalRegionSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQGlobalRegionRemove" :selected="selected_hq_global_regions"></v-select>
                      <!-- <input class="form-control" id="hq_country" name="hq_country" v-model="filterInvestorForm.hq_country"> -->
                    </div>
                  </div>

                  <!--

Limited Partner Type - Organization CONTAINS {insert}

                  -->

                </div>
                <button class="btn btn-danger btn-sm pull-right" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                <span class="btn btn-info btn-sm" @click.prevent="getExportLink">Export</span>
              </div>
            </div>
          </transition>
          <transition name="fade" v-if="hasPermission('create-user')">
            <div class="card border-bottom" v-if="showCreatePanel">
              <div class="card-body p-4">
                <form @submit.prevent="submit" @keydown="newInvestorForm.errors.clear($event.target.name)" autocomplete="off">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="row">
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('investor.name')}}</label>
                            <input class="form-control" type="text" value="" v-model="newInvestorForm.name" name="name" :placeholder="trans('investor.name')">
                            <show-error :form-name="newInvestorForm" prop-name="name"></show-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                  <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                </form>
              </div>
            </div>
          </transition>
          <div class="card" v-if="investors.total">
            <div class="card-body">
              <div class="table-responsive" v-if="hasPermission('list-user') && investors.total">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th scope="col">Label</th>
                    <th scope="col">{{trans('investor.name')}}</th>
                    <th scope="col">{{trans('investor.contact_person')}}</th>
                    <th scope="col" class="table-option">{{trans('general.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="investor in investors.data">
                    <td style="font-size:12px;width:100px;" v-text="investor.label"></td>
                    <td v-text="investor.name"></td>
                    <td v-text="investor.contact_person"></td>
                    <td class="table-option">
                      <div class="btn-group">
                        <router-link :to="`/account/investors/${investor.id}`" class="btn btn-info btn-sm" v-tooltip="trans('investor.view_investor')"><i class="fas fa-arrow-circle-right"></i></router-link>
                        <button class="btn btn-danger btn-sm" :key="investor.id" v-if="hasPermission('delete-user')" v-confirm="{ok: confirmDelete(investor), message: 'Do you really want to delete the investor?', okText: 'Delete', cancelText: 'Cancel'}" v-tooltip="trans('investor.delete_investor')"><i class="fas fa-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
             <pagination-record :page-length.sync="filterInvestorForm.page_length" :records="investors" @updateRecords="getInvestors"></pagination-record>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import switches from 'vue-switches'
import vSelect from 'vue-multiselect'
import dateRangePicker from '../../components/date-range-picker'
import sortBy from '../../components/sort-by'

export default {
  components: {switches,vSelect,dateRangePicker,sortBy},
  data() {
    return {
      showCreatePanel: false,
      investors: {
        total: 0,
        data: []
      },
      newInvestorForm: new Form({
        name: ''
      }),
      filterInvestorForm: {
        name: '',
        label: '',
        contact_person: '',
        preferred_geography:[],
        preferred_fund_type_organization:[],
        limited_partner_type_organization:[],
        investment_structure:[],
        hq_country:[],
        hq_global_sub_region:[],
        hq_global_region:[],
        sort_by : 'name',
        order: 'asc',
        page_length: 100
      },
      fund_categories: '',
      fund_types: '',
      currencies: '',
      continents: [],
      countries: [],
      regions: [],
      investor_preferred_fund_types: [],
      preferred_fund_type_organization: [],
      selected_preferred_fund_type_organizations: [],
      selected_limited_partner_type_organizations: [],
      selected_hq_global_sub_regions: [],
      selected_hq_global_regions: [],
      preferred_geography: [],
      selected_preferred_geographies:[],
      investment_structure: [],
      selected_investment_structures: [],
      selected_hq_countries: [],
      limited_partner_type_organizations: [
        {
          id: 1,
          name: "Foundation"
        },
        {
          id: 2,
          name: "Government Agency"
        },
        {
          id: 3,
          name: "Insurance Company"
        },
        {
          id: 4,
          name: "Public Pension Fund"
        },
        {
          id: 5,
          name: "Sovereign Wealth Fund"
        },
        {
          id: 6,
          name: "Banking Institution"
        },
        {
          id: 7,
          name: "Corporate Pension"
        },
        {
          id: 8,
          name: "Corporation"
        },
        {
          id: 9,
          name: "Direct Investment"
        },
        {
          id: 10,
          name: "Endowment"
        },
        {
          id: 11,
          name: "Fund of Funds"
        },
        {
          id: 12,
          name: "Investment Advisor"
        },
        {
          id: 13,
          name: "Money Management Firm"
        },
        {
          id: 14,
          name: "Private Investment Fund"
        },
        {
          id: 15,
          name: "Wealth Management Firm"
        },
        {
          id: 16,
          name: "Family Office (Multi)"
        },
        {
          id: 17,
          name: "Economic Development Agency"
        },
        {
          id: 18,
          name: "Mutual Fund Company"
        },
        {
          id: 19,
          name: "Real Estate Investment Company"
        },
        {
          id: 20,
          name: "Secondary LP"
        },
        {
          id: 21,
          name: "Union Pension Fund"
        },
        {
          id: 22,
          name: "University (Non-Endowment)"
        },
        {
          id: 23,
          name: "Family Office (Single)"
        },
        {
          id: 24,
          name: "High-net-worth Investor"
        },
        {
          id: 25,
          name: "Discretionary Advisor"
        },
        {
          id: 26,
          name: "Other Limited Partner"
        },
        {
          id: 27,
          name: "Institutional Investor"
        }
      ],
      investment_structures : [
        {
          id: 1,
          name: "Direct Deal Investment"
        },
        {
          id: 2,
          name: "Fund Investment"
        }
      ],
      showFilterPanel: false,
      timeout: null,
      orderByOptions: [
        {
          value: 'name',
          translation: i18n.investor.name
        },
        {
          value: 'contact_person',
          translation: i18n.investor.contact_person
        },
        {
          value: 'created_at',
          translation: i18n.investor.created_at
        }
      ],
      labels : [
        {
          id: 1,
          name: "Close Relationship"
        },
        {
          id: 2,
          name: "USE AN OCIO"
        },
        {
          id: 3,
          name: "DON'T CONTACT"
        },
        {
          id: 4,
          name: "INACTIVE"
        },
        {
          id: 5,
          name: "SUBMIT PROPOSALS THROUGH PORTAL"
        },
        {
          id: 6,
          name: "WANT TO BE APPROACHED"
        }
      ],
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/account/dashboard');
    }
    this.prerequisite();

  },
  methods: {
    prerequisite(){
      axios.get('/api/user/profile/questionnaire/pre-requisite')
          .then(response => response.data)
          .then(response => {
            this.fund_categories  = response.fund_categories;
            this.fund_types       = response.fund_types;
            this.continents       = response.continents;
            this.regions          = response.regions;
            this.countries        = response.countries;
            this.currencies       = response.currencies;
            this.investor_preferred_fund_types = response.investor_preferred_fund_types;
            this.getInvestors();
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getInvestors(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterInvestorForm);
      axios.get('/api/investor?show=all&page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.investors = response.investors;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getExportLink(){
      let url = helper.getFilterURL(this.filterInvestorForm);
      window.location.href = '/api/investors/export?show=all_export&page=' + url;
    },
    confirmDelete(investor){
      return dialog => this.deleteInvestor(investor);
    },
    deleteInvestor(investor){
      axios.delete('/api/investor/'+investor.id)
          .then(response => response.data)
          .then(response => {
            toastr.success(response.message);
            this.getInvestors();
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    onPreferredGeographySelect(selectedOption){
      this.filterInvestorForm.preferred_geography.push(selectedOption.name);
    },
    onPreferredGeographyRemove(removedOption){
      this.filterInvestorForm.preferred_geography.splice(this.filterInvestorForm.preferred_geography.indexOf(removedOption.name), 1);
    },
    onInvestmentStructureSelect(selectedOption){
      this.filterInvestorForm.investment_structure.push(selectedOption.name);
    },
    onInvestmentStructureRemove(removedOption){
      this.filterInvestorForm.investment_structure.splice(this.filterInvestorForm.investment_structure.indexOf(removedOption.name), 1);
    },
    onInvestorPreferredFundTypeSelect(selectedOption){
      this.filterInvestorForm.preferred_fund_type_organization.push(selectedOption.name);
    },
    onInvestorPreferredFundTypeRemove(removedOption){
      this.filterInvestorForm.preferred_fund_type_organization.splice(this.filterInvestorForm.preferred_fund_type_organization.indexOf(removedOption.name), 1);
    },
    onLimitedPartnerTypeOrganizationSelect(selectedOption){
      this.filterInvestorForm.limited_partner_type_organization.push(selectedOption.name);
    },
    onLimitedPartnerTypeOrganizationRemove(removedOption){
      this.filterInvestorForm.limited_partner_type_organization.splice(this.filterInvestorForm.limited_partner_type_organization.indexOf(removedOption.name), 1);
    },
    onHQCountrySelect(selectedOption){
      this.filterInvestorForm.hq_country.push(selectedOption.name);
    },
    onHQCountryRemove(removedOption){
      this.filterInvestorForm.hq_country.splice(this.filterInvestorForm.hq_country.indexOf(removedOption.name), 1);
    },
    onHQGlobalRegionSelect(selectedOption){
      this.filterInvestorForm.hq_global_region.push(selectedOption.name);
    },
    onHQGlobalRegionRemove(removedOption){
      this.filterInvestorForm.hq_global_region.splice(this.filterInvestorForm.hq_global_region.indexOf(removedOption.name), 1);
    },
    onHQGlobalSubRegionSelect(selectedOption){
      this.filterInvestorForm.hq_global_sub_region.push(selectedOption.name);
    },
    onHQGlobalSubRegionRemove(removedOption){
      this.filterInvestorForm.hq_global_sub_region.splice(this.filterInvestorForm.hq_global_sub_region.indexOf(removedOption.name), 1);
    },
    submit(){
      this.newInvestorForm.post('/api/investor')
          .then(response => {
            toastr.success(response.message);
            this.$router.push('/account/investors/'+response.id);
          })
          .catch(error => {
            helper.showErrorMsg(error);
          });
    },
  },
  watch: {
    filterInvestorForm: {
      handler(val) {
        clearTimeout(this.timeout); // Lösche vorherigen Timer
        this.timeout = setTimeout(() => {
          this.getInvestors(); // Aufruf nach Verzögerung
        }, 500); // Verzögerung in Millisekunden
      },
      deep: true,
    }
  },
  filters: {
    moment(date) {
      return helper.formatDate(date);
    }
  }
}
</script>
